import { Grid, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import React from "react";
import { ContactForm } from "../contact/contact-form";
import { TopNav } from "src/layouts/dashboard/marketing/top-nav";

interface OnboardingFormProps {}

const OnboardingForm: React.FC<OnboardingFormProps> = () => {
  return (
    <>
      <Box mb={{ xs: 4, lg: "100px" }}>
        <TopNav />
      </Box>
      <Grid container component="main" sx={{ flexGrow: 1 }}>
        <Grid
          item
          xs={12}
          lg={6}
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "dark" ? "neutral.800" : "neutral.50",
            pt: 2,
            pb: { xs: 4, lg: 8 },
          }}
        >
          <Container maxWidth="md" sx={{ pl: { lg: 15 } }}>
            <Typography sx={{ mb: { xs: 2, md: 3 }, mt: { xs: 2, md: 3 } }} variant="h1">
              Vamos nos conhecer
            </Typography>
            <Typography sx={{ mb: { xs: 2, md: 3 } }} variant="body1">
              Ajudamos empresas a criar produtos digitais incríveis. Vamos conversar sobre como
              podemos ajudar você.
            </Typography>
          </Container>
        </Grid>
        <Grid
          item
          xs={12}
          lg={6}
          sx={{
            backgroundColor: "background.paper",
            px: { xs: 2, sm: 3, lg: 6 },
            py: { xs: 3, lg: 5 },
          }}
        >
          <Typography sx={{ mb: { xs: 3, lg: 5 } }} variant="h6">
            Preencha o formulário abaixo
          </Typography>
          <Container maxWidth="md">
            <ContactForm />
          </Container>
        </Grid>
      </Grid>
    </>
  );
};

export default OnboardingForm;
